import { defineStore } from 'pinia'
import { reactive, ref, unref } from 'vue'
import { $fetch } from 'ofetch'

const defaultState = {
  activeBusiness: undefined,
  activeBusinessUuid: undefined,
  businessId: undefined,
  business: {
    id: null,
    name: null,
    uuid: null,
    user_id: null,
    logo: null,
  },
}

export const useAdminStore = defineStore('admin', () => {
  const log = useLogger('store:admin')
  const activeBusiness = ref(defaultState.activeBusiness)
  const activeBusinessUuid = ref(defaultState.activeBusinessUuid)
  const businessId = ref(defaultState.businessId)
  const business = reactive({
    id: defaultState.business.id,
    name: defaultState.business.name,
    uuid: defaultState.business.uuid,
    user_id: defaultState.business.user_id,
    logo: defaultState.business.logo,
  })

  function storeReset() {
    activeBusiness.value = defaultState.activeBusiness
    activeBusinessUuid.value = defaultState.activeBusinessUuid
    businessId.value = defaultState.businessId
    business.id = defaultState.business.id
    business.name = defaultState.business.name
    business.uuid = defaultState.business.uuid
    business.user_id = defaultState.business.user_id
    business.logo = defaultState.business.logo
  }

  function reset() {
    // Reset all store state to initial values
    activeBusiness.value = defaultState.activeBusiness
    activeBusinessUuid.value = defaultState.activeBusinessUuid
    businessId.value = defaultState.businessId
    business.id = defaultState.business.id
    business.name = defaultState.business.name
    business.uuid = defaultState.business.uuid
    business.user_id = defaultState.business.user_id
    business.logo = defaultState.business.logo

    log.info('✅ Admin store reset to initial state')
  }

  async function getBusinessInfo(buuid: string) {
    try {
      const res = await $fetch(`/api/business/${buuid}`, {
        method: 'GET',
      })

      setBusinessData(res)
      return res
    }
    catch {
      log.error('error getting business')
    }
  }

  function setBusinessData(data: any) {
    const unRefData = unref(data)

    if (Object.hasOwnProperty.call(unRefData, 'name')) {
      business.name = unRefData.name
    }

    if (Object.hasOwnProperty.call(unRefData, 'id')) {
      business.id = unRefData.id
    }

    if (Object.hasOwnProperty.call(unRefData, 'uuid')) {
      business.uuid = unRefData.uuid
    }

    if (Object.hasOwnProperty.call(unRefData, 'user_id')) {
      business.user_id = unRefData.user_id
    }

    business.logo = unRefData.business_photo
  }

  const businessName = computed(() => {
    if (business.name) {
      return business.name
    }
    else {
      return undefined
    }
  })

  return {
    activeBusiness,
    activeBusinessUuid,
    businessId,
    business,
    setBusinessData,
    // updateBusinessData,
    storeReset,
    reset,
    businessName,
    getBusinessInfo,
  }
}, {
  persist: {
    key: 'admin',
    paths: ['activeBusiness', 'activeBusinessUuid', 'businessId', 'business'],
  },
})
